// components/ApiErrorDisplay.tsx
import React from 'react';
import { ICONS } from './constants';

interface ApiErrorDisplayProps {
  error: any; // FIX: Changed to 'any' to accept different error structures.
  serviceName: string;
}

const ApiErrorDisplay: React.FC<ApiErrorDisplayProps> = ({ error, serviceName }) => {
  if (!error) return null;

  // Safely access the message property from any kind of error object.
  const errorMessage = typeof error === 'string' ? error : (error.message || 'An unknown error occurred.');

  return (
    <div className="mt-4 p-4 bg-red-50 border border-red-200 rounded-md">
      <div className="flex items-start">
        <div className="flex-shrink-0 text-red-500">{ICONS.error}</div>
        <div className="ml-3">
          <h3 className="text-sm font-semibold text-red-800">Error in {serviceName}</h3>
          <p className="mt-1 text-sm text-red-700">{errorMessage}</p>
        </div>
      </div>
    </div>
  );
};

export default ApiErrorDisplay;
